<template>
  <div
    class="app-snackbar"
    :class="{
      opening: state === STATE_OPENING,
      opened: state === STATE_OPENED,
      closing: state === STATE_CLOSING,
      closed: state === STATE_CLOSED,
      left: direction === 'left',
      bottom: direction === 'bottom',
      success,
    }"
  >
    <div class="app-snackbar-wrapper">
      <h3 v-if="title" v-html="title" class="title"></h3>
      <div v-if="content" v-html="content" class="content sm-line-height"></div>
    </div>
  </div>
</template>

<script>
import { sleep } from '@/helpers'

const STATE_CLOSED = 0
const STATE_CLOSING = 1
const STATE_OPENING = 2
const STATE_OPENED = 3

export default {
  name: 'AppSnackbar',

  data() {
    return {
      STATE_CLOSED,
      STATE_CLOSING,
      STATE_OPENING,
      STATE_OPENED,

      state: STATE_CLOSED,
      closeTimer: undefined,
    }
  },

  props: {
    duration: {
      type: Number,
      required: false,
    },

    title: {
      type: String,
      required: false,
    },

    content: {
      type: String,
      required: false,
    },

    direction: {
      type: String,
      default: 'left',
    },

    autoDuration: {
      type: Boolean,
      default: true,
    },

    success: {
      type: Boolean,
      default: true,
    },
  },

  beforeCreate() {
    this.$on('opening', () => {
      this.state = STATE_OPENING
    })
      .$on('opened', () => {
        this.state = STATE_OPENED
        this.startCountdown()
      })
      .$on('closing', () => {
        this.state = STATE_CLOSING
      })
      .$on('closed', () => {
        this.state = STATE_CLOSED
      })
  },

  mounted() {
    this.$el.addEventListener('transitionend', event => {
      if (event.propertyName !== 'opacity') return

      switch (this.state) {
        case STATE_OPENING:
          this.$emit('opened', this)
          break

        case STATE_CLOSING:
          this.$emit('closed', this)
          break
      }
    })
  },

  methods: {
    startCountdown() {
      let duration = this.duration

      if (duration === Infinity) return
      if (!duration) duration = app.getReadingTime(this.$el)

      if (this.closeTimer) clearTimeout(this.closeTimer)

      if (this.duration > 0)
        this.closeTimer = setTimeout(this.close, this.duration)
    },

    async open() {
      return new Promise(async (resolve, reject) => {
        if ([STATE_OPENING, STATE_OPENED].includes(this.state)) return resolve()

        this.$once('opened', resolve)

        await sleep(200)

        this.$emit('opening', this)
      })
    },

    async close() {
      return new Promise((resolve, reject) => {
        if ([STATE_CLOSING, STATE_CLOSED].includes(this.state)) return resolve()

        this.$once('closed', resolve)
        this.$emit('closing', this)
      })
    },
  },
}
</script>

<style lang="scss" scoped>
@use '@/styles/settings.scss' as *;

.app-snackbar {
  $transitionDuration: 400ms;
  padding: 0.5em;
  border-radius: 6px;
  opacity: 0;
  transition:
    transform $transitionDuration,
    opacity $transitionDuration;
  box-shadow:
    1px 1px 10px rgba(0, 0, 0, 0.5),
    inset -3px -3px 10px rgba(0, 0, 0, 0.1);
  font-size: 85%;

  &.left {
    transform: translateX(-100%);

    &.opened,
    &.opening {
      transform: translateX(0);
    }
  }

  &.bottom {
    transform: translateY(100%);

    &.opened,
    &.opening {
      transform: translateY(0);
    }
  }

  &.opened,
  &.opening {
    opacity: 1;
  }

  &.success {
    color: #fff;
    background-color: #28a745;
  }

  .title {
    margin: 0 0 0.5em;
    font-size: 125%;
  }
}
</style>
